import { InputText } from '../../../classes/input-text';
import { InputBase } from '../../../classes/input-base';

export class BookForm {
	title = new InputText({
		key: 'title',
		label: 'Book Title',
		required: true,
	});

	author = new InputText({
		key: 'author',
		label: 'Author',
		required: true,
	});

	description = new InputText({
		key: 'description',
		label: 'Book Description for Promotion',
		required: false,
	});

	promoPrice = new InputText({
		key: 'promo_price',
		label: 'Promo Price',
		require: false,
		type: 'number',
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited (now Kindle+)?',
		controlType: 'checkbox',
		value: false,
	});

	kindleCountdownDeal = new InputBase({
		key: 'kindleCountdownDeal',
		label: 'Is this a Kindle Countdown Deal?',
		controlType: 'checkbox',
		value: false,
	});

	bookLength = new InputText({
		key: 'bookLength',
		label: 'Page Count (Optional)',
		required: false,
		type: 'number',
		min: 0,
	});

	isSeries = new InputBase({
		key: 'isSeries',
		label: 'Is this a series?',
		controlType: 'checkbox',
		value: false,
	});

	nameOfSeries = new InputText({
		key: 'nameOfSeries',
		label: 'Name of Series',
		required: false,
	});

	numberOfBooksInSeries = new InputText({
		key: 'numberOfBooksInSeries',
		label: 'Total Books in Series',
		required: false,
		type: 'number',
		min: 1,
	});

	bookNumber = new InputText({
		key: 'bookNumber',
		label: 'Position of This Book',
		required: false,
		type: 'number',
		min: 1,
	});

	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Link',
		placeholder: 'https://www.amazon.com/dp/B07JZQZQZQ',
	});

	apple = new InputText({
		key: 'apple',
		label: 'Apple Books Link',
		placeholder: 'https://itunes.apple.com/us/book/id123456789',
	});

	nook = new InputText({
		key: 'nook',
		label: 'Nook Link',
		placeholder: 'https://www.barnesandnoble.com/w/123456789',
	});

	kobo = new InputText({
		key: 'kobo',
		label: 'Kobo Link',
		placeholder: 'https://www.barnesandnoble.com/w/123456789',
	});

	googleplay = new InputText({
		key: 'googleplay',
		label: 'Google Play Link',
		placeholder: 'https://www.barnesandnoble.com/w/123456789',
	});

	terms = new InputBase({
		key: 'terms',
		label: '???',
		controlType: 'checkbox',
		value: false,
	});
}
